import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import { debounce } from 'lodash';
import helpers from 'helpers';
import ButtonPrimary from 'components/atoms/buttons/standard/Primary';
import ThirdManPhone from 'assets/third-man-phone.jpg';
import Confirmation from 'components/molecules/modal/Confirmation';

const TopIcon = styled.i`
    font-size: 64px;

    color: ${props => props.theme.colors.lochmara};
`;

const CheckedIcon = styled(TopIcon)`
    font-size: 24px;
`;

const ContentCol = styled(Col)`
    text-align: center;
    flex: 7;

    & .add-padding {
        padding: 36px 0;
    }

    & h2 {
        margin-bottom: 20px;
        line-height: 40px;
        font-size: 32px;
    }

    & p {
        text-align: left;
        margin-bottom: 20px;
        font-size: 16px;
        line-height: 24px;
    }

    & button {
        margin-top: 20px;
    }
`;

const FlexCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ImageCol = styled(Col)`
    padding-right: 0;
    flex: 5;
    justify-content: center;
    align-items: center;
`;

const Image = styled.div`
    background-image: url(${ThirdManPhone});
    background-size: cover;
    height: 100%;
`;

const BorderContainer = styled.div`
    border: 1px solid #ccc;
    box-shadow: 0 1px 2px 0 rgba(127,127,127,0.4);
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    margin-bottom: 40px;
`;

class ChannelUpsell extends Component {
    constructor(props) {
        super(props);

        this.clickButton = debounce(this.clickButton.bind(this), 250, { leading: true, trailing: false });
        this.resetModal = this.resetModal.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
        this.state = {
            mountConfirmation: false
        };
    }

    clickButton() {
        this.setState({ mountConfirmation: true });
    }

    submitRequest() {
        this.props.buttonClick();
        this.resetModal();
    }

    resetModal() {
        setTimeout(() => this.setState({ mountConfirmation: false }), 1000);
    }

    componentDidMount() {
        if (this.props.onMount) {
            this.props.onMount();
        }
    }

    render() {
        return (
            <BorderContainer>
                <ContentCol mdOffset={1} md={6} xsOffset={1} xs={10}>
                    <div className="add-padding">
                        <FlexCenter>
                            <TopIcon className={this.props.icon} />
                        </FlexCenter>
                        <h2>You aren't currently running {this.props.channelDisplay}.</h2>
                        <p>
                            Adding {this.props.channelDisplay} to your existing
                            tactics will increase your exposure to your customers.
                            Combining tactics amplifies your message by reaching
                            customers everywhere they consume content.
                        </p>
                        <p>
                            Click the button below to request adding {this.props.channelDisplay} to your
                            campaign today!
                        </p>
                        {
                            !this.props.successfulRequest ?
                                (
                                    <ButtonPrimary onClick={this.clickButton}>
                                        REQUEST INFORMATION ON {
                                            helpers.convertToDisplayValue(this.props.channel).toUpperCase()
                                        } CHANNEL
                                    </ButtonPrimary>
                                ) : (
                                    <FlexCenter>
                                        <CheckedIcon className="icon-circle-check"/>
                                        <span style={{ paddingLeft: '8px', lineHeight: '28px', fontSize: '16px', fontWeight: 700 }}>Your request has been sent.</span>
                                    </FlexCenter>
                                )
                        }
                    </div>
                </ContentCol>
                {/* makes an empty column for small displays to keep content centered */}
                <Col mdHidden={true} lgHidden={true} xs={1}></Col>
                <ImageCol mdOffset={1} md={4} xsHidden={true} smHidden={true}>
                    <Image/>
                </ImageCol>

                {this.state.mountConfirmation ?
                    <Confirmation
                        dispose={this.resetModal}
                        reject={this.resetModal}
                        resolve={this.submitRequest}
                        title={`Request Information on ${this.props.channelDisplay} Channel`}
                        confirmation={`Your Goodway Group Account Director will contact you shortly after submitting your request to discuss whether ${this.props.channelDisplay} is right for you.`}
                        okLabel="Submit Request"/>
                    : null}
            </BorderContainer>
        );
    }
}

ChannelUpsell.propTypes = {
    channel: PropTypes.string.isRequired,
    channelDisplay: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    buttonClick: PropTypes.func.isRequired,
    onMount: PropTypes.func,
    successfulRequest: PropTypes.bool
};

export default ChannelUpsell;



// WEBPACK FOOTER //
// ./src/components/molecules/ChannelUpsell.js